import { useMutation } from '@tanstack/react-query';
import { SendCustomNotification } from '../../../Api/customNotification';

export const useMutateSendCustomNotification = () =>
  useMutation({
    mutationFn: (data) => SendCustomNotification(data),
  });
